// Onzichtbare tekens uit plak-werk (Airtable, WhatsApp, Outlook): zero-width (U+200B–U+200D),
// richtingstekens (U+200E/U+200F, U+202A–U+202E), word joiner (U+2060–U+2064) en BOM (U+FEFF)
// eruit; harde spaties (NBSP U+00A0, U+2007, U+202F) worden een gewone spatie.
const ONZICHTBAAR = /[\u200B-\u200F\u202A-\u202E\u2060-\u2064\uFEFF]/g;
const HARDE_SPATIE = /[\u00A0\u2007\u202F]/g;

/**
 * Eén notatie voor telefoonnummers op het callsheet. Zelfde regels als telefoon_nl in
 * ai-engine/services/telefoon.py (PDF + docx): '06 12 34 56 78' voor NL mobiel,
 * '010 123 4567' voor vast, +31/0031 wordt 0; buitenlandse of onherkenbare nummers
 * blijven staan. Alleen weergave — de opgeslagen waarde blijft ongemoeid.
 */
export function telefoonNl(nummer) {
  const waarde = Array.isArray(nummer) ? nummer[0] : nummer;
  const ruw = String(waarde || '').replace(ONZICHTBAAR, '').replace(HARDE_SPATIE, ' ')
    .split(/\s+/).filter(Boolean).join(' ');
  if (!ruw) return '';
  // Alleen cijfers (ASCII), spaties en gangbare scheidingstekens; 'bel Falco' of
  // '06… (alleen WhatsApp)' blijft zoals ingevuld.
  if (!/^[0-9+ ().\-/]+$/.test(ruw)) return ruw;
  let cijfers = ruw.replace(/[^0-9]/g, '');
  if (ruw.startsWith('+31') || cijfers.startsWith('0031')) {
    cijfers = `0${cijfers.slice(cijfers.startsWith('0031') ? 4 : 2).replace(/^0+/, '')}`;
  } else if (ruw.startsWith('+') || cijfers.startsWith('00')) {
    return ruw;
  }
  if (cijfers.length === 9 && cijfers.startsWith('6')) cijfers = `0${cijfers}`;
  if (cijfers.length !== 10 || !cijfers.startsWith('0')) return ruw;
  if (cijfers.startsWith('06')) return `06 ${cijfers.slice(2, 4)} ${cijfers.slice(4, 6)} ${cijfers.slice(6, 8)} ${cijfers.slice(8)}`;
  return `${cijfers.slice(0, 3)} ${cijfers.slice(3, 6)} ${cijfers.slice(6)}`;
}
